import { useContext, useMemo } from "react";
import { Environment } from "../environment";
import { Loadable } from "../loadable";
import {
  CityService,
  CityServiceContext,
  DivisionServiceContext,
} from "../services";

export const useGameLoadable = function (gameId?: string) {
  const city: CityService | null = useContext(CityServiceContext);
  const divisionService = useContext(DivisionServiceContext);

  return useMemo(() => {
    return Loadable.create(async () => {
      const loadable =
        Environment.type === "geographic"
          ? city?.activeGameStore
          : divisionService.loadableDivisionStore();
      const store = await loadable?.ensuredValue();

      if (!gameId) return undefined;
      return store?.findGameById(gameId);
    });
  }, [city?.activeCity]);
};
